// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../components/Table";
// Engine
import { axiosAPI } from "../../../engine/config/axios";
// Config

const SubscriptionsList:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'subscriptions', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.subscriptionsList.table}
    apiParams={apiParams}
    sortingMode="multiple"
    gridName="subscriptions"
    gridParams={gridParams}
  />;
}

function SubscriptionsListPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<SubscriptionsList hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default SubscriptionsListPortal;
